import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "19",
      cy: "19",
      r: "17.75",
      stroke: "#37A0EB",
      "stroke-width": "2.5"
    }, null, -1),
    _createElementVNode("path", { d: "M10.962 23.207c-.316 0-.618.129-.842.358a1.24 1.24 0 0 0-.349.864v1.22c0 .973.377 1.905 1.047 2.592a3.527 3.527 0 0 0 2.526 1.073h11.312c.948 0 1.856-.386 2.526-1.073a3.712 3.712 0 0 0 1.047-2.591v-1.221c0-.437-.227-.84-.596-1.058a1.165 1.165 0 0 0-1.19 0 1.228 1.228 0 0 0-.596 1.058v1.22c0 .325-.125.636-.349.865a1.176 1.176 0 0 1-.842.357H13.344c-.316 0-.619-.128-.842-.357a1.237 1.237 0 0 1-.349-.864v-1.221c0-.324-.125-.635-.348-.864a1.176 1.176 0 0 0-.842-.358Z" }, null, -1),
    _createElementVNode("path", { d: "M19 9.771c-.316 0-.619.13-.842.358-.223.23-.349.54-.349.864v8.959l-1.786-1.833a1.214 1.214 0 0 0-1.569-.19 1.24 1.24 0 0 0-.164 1.869l2.87 2.939c.489.5 1.151.78 1.841.78s1.353-.28 1.841-.78l2.873-2.938a1.24 1.24 0 0 0-.163-1.869 1.214 1.214 0 0 0-1.57.19l-1.786 1.832v-8.96c0-.324-.126-.636-.35-.865A1.175 1.175 0 0 0 19 9.771Z" }, null, -1)
  ]))]))
}
export default { render: render }